import { Component } from "./Component";

export class Group extends Component {
    parentEltD3 = null;

    static createRoot(data, parentEltD3) {
        let component = new Group(data);
        component.parentEltD3 = parentEltD3;
        component.type = Component.TYPE_GROUP;
        return component._init(data);
    }

    static create(data, parent) {
        let component = new Group(data, parent);
        component.parentEltD3 = parent.eltD3;
        component.type = Component.TYPE_GROUP;
        return component._init(data);
    }

    _init(data) {
        this.eltD3 = this.parentEltD3
            .append("g")
            .data([data])
            .attr("id", data.UUID)
            .attr("class", "component-group");

        this.elt = this.eltD3.node();

        return this;
    }
}



// WEBPACK FOOTER //
// ./src/components/plano/components/Group.js